import * as actionTypes from './actionTypes';


import axios from 'axios';

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    }
}

export const authSuccess = (token, userId, refreshToken) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        idToken: token,
        refreshToken: refreshToken,
        userId: userId
    }
}

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    }
}

export const logout = () => {

    localStorage.removeItem('token')
    localStorage.removeItem('refresh')
    localStorage.removeItem('expirationDate')
    localStorage.removeItem('userId')


    return {
        type: actionTypes.AUTH_LOGOUT
    }
}


export const checkAuthTimeout = (expirationTime) => {
    return dispatch => {
        setTimeout(() => {
            dispatch(logout())
        }, expirationTime * 1000)   // logs user out after one hour currently
    }
}

// export const modalClicked = () => {
//     return dispatch => {
//         dispatch(modalClicked())
//     }
// }


export const auth = (email, password) => {
    return dispatch => {
        dispatch(authStart())
        // Authenticate user here

        const authData = {
            email: email,
            password: password,
            returnSecureToken: true
        }
        

        axios.post('https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyBwZGamuSOOSSdfjIZrzAUpa2-slG8I0rs', authData)
            .then(response => {

                const expirationDate = new Date(new Date().getTime() + response.data.expiresIn * 1000)
                
                localStorage.setItem('token', response.data.idToken)
                localStorage.setItem('refresh', response.data.refreshToken)
                localStorage.setItem('expirationDate', expirationDate)
                localStorage.setItem('userId', response.data.localId)
                dispatch(authSuccess(response.data.idToken, response.data.localId, response.data.refreshToken))
                dispatch(checkAuthTimeout(response.data.expiresIn))
            })
            .catch(error => {

                // can make own error message
                dispatch(authFail(error.response.data.error))
            })

        // console.log(email + ', ' + password)
        
    }
}


export const setAuthRedirectPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    };
};


export const authCheckState = () => {
    return dispatch => {

        const token = localStorage.getItem('token')
        if (!token) {
            dispatch(logout());
        } else {
            const expirationDate = new Date(localStorage.getItem('expirationDate'))

            if (expirationDate > new Date()) {
                const userId = localStorage.getItem('userId')
                dispatch(authSuccess(token, userId))
                dispatch(checkAuthTimeout((expirationDate.getTime() - new Date().getTime()) / 1000 ))
            } else {
                dispatch(logout())
            }

            
        }

    }
}



// WEBPACK FOOTER //
// ./src/store/actions/auth.js